import React from 'react';
import DefaultMaterialTable from '../../../../common/DefaultMaterialTable';
import getColumns from './columns';

function Items({ values, query, filterBtn, setInvoice, loading, setValues, report }) {
    const filters = query;
    const columns = getColumns(setInvoice);

    return (
        <DefaultMaterialTable
            title={'Outstanding Courses'}
            filters={filters}
            columns={columns}
            data={values}
            options={{ sorting: true }}
            filterBtn={filterBtn}
            loading={loading}
            setValues={setValues}
            canShowFilters={false}
            showFiltersOnHeader={false}
            report={report}
        />
    );
}

export default Items;
